import { render } from "./PaperLayers.vue?vue&type=template&id=34eebd97"
import script from "./PaperLayers.vue?vue&type=script&lang=js"
export * from "./PaperLayers.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__